import { Box } from '@mui/material';
import React from 'react';

import type { AsyncActionStatus } from '../../actions/common.actionTypes';
import { routes } from '../../constants';
import type { Collection, Pagination } from '../../types/AppContent';
import { hasNext } from '../../utils/pagination';
import useResponsivePadding from '../../utils/useResponsivePadding';
import ItemsList from '../ItemsList';
import OwnCollectionOverviewEmptyState from '../OwnCollectionOverview/OwnCollectionOverviewEmptyState';

interface CuratedCollectionOverviewItemsListProps {
	collection: Collection;
	collectionStatus: AsyncActionStatus;
	collectionId: string;
	collectionPagination: Pagination;
	loadNext: () => void;
}

const CuratedCollectionOverviewItemsList = ({
	collection,
	collectionStatus,
	collectionId,
	collectionPagination,
	loadNext,
}: CuratedCollectionOverviewItemsListProps) => {
	const cardPadding = useResponsivePadding();

	return collection.contentsCount === 0 ? (
		<OwnCollectionOverviewEmptyState />
	) : (
		<Box
			data-testid="curated-collection-overview-items-list"
			sx={{
				padding: `${0} ${cardPadding} ${cardPadding} ${cardPadding}`,
			}}
		>
			<ItemsList
				isLoading={collectionStatus === 'loading'}
				hasNext={hasNext(collectionPagination)}
				total={collectionPagination.total}
				loadNext={loadNext}
				items={collection.contents}
				linkRoot={[routes.followed.root, collectionId]}
			/>
		</Box>
	);
};

export default CuratedCollectionOverviewItemsList;
